import ModalAddEditAllowlist from "./modal-add-edit-allowlist";

export default ModalAddEditAllowlist;